/**
 * queryClient.ts
 *
 * Shared React Query client instance for CBOps.
 *
 * Cache strategy:
 *   staleTime  — 60 s   : data is considered fresh for 60 seconds; no background
 *                          refetch will fire while the data is fresh.
 *   gcTime     — 5 min  : unused cache entries are garbage-collected after 5 minutes
 *                          (previously called cacheTime in v4).
 *   retry      — 2      : failed queries are retried twice before showing an error.
 *   refetchOnWindowFocus — true (default): re-validates data when the user switches
 *                          back to the browser tab, keeping dashboards current.
 *
 * Usage:
 *   import { queryClient } from './queryClient';
 *   // wrap in <QueryClientProvider client={queryClient}> in App.tsx
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:           60 * 1000,        // 60 seconds
      gcTime:              5  * 60 * 1000,   // 5 minutes
      retry:               2,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 1,
    },
  },
});
